export const DiggerProductVersion = "0.40.1";
export const BackendURL = process.env.REACT_APP_BACKEND_URL;
export const UseMockedApi = process.env.REACT_APP_USE_MOCKED_API;
export const FeatureEnvPermissions =
  process.env.REACT_APP_FEATURE_ENV_PERMISSIONS;
